module.exports = __webpack_public_path__ + "static/media/share.a8081980.svg";